var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};
class RingConfigurator {

    constructor() {

        this.root = document.querySelector(".rc-heading--text")
        this.priceEl = document.querySelector(".rc-price-value")
        this.button = document.getElementById("rc-addtocart")
        this.stickyBar = document.getElementById("rcStickyBar")
        this.stickyPrice = document.getElementById("rcStickyPrice")
        this.stickyStone = document.getElementById("rcStickyStone")
        this.stickyMetal = document.getElementById("rcStickyMetal")
        this.stickyRing = document.getElementById("rcStickyRing")
        this.stickyAdd = document.getElementById("rcStickyAdd")

        this.selected = {
            stone: null,
            metal: null,
            ring: null,
            express: false,
            engraving: false
        }

        this.init()

    }

    init() {

        this.initStone()
        this.initMetal()
        this.initRingType()
        this.initExpress()
        this.initPersonalEngraving()
        this.updatePrice()
        this.initStickyBar()

    }

    initStickyBar() {

        const config = this.root

        window.addEventListener("scroll", () => {

            const rect = config.getBoundingClientRect()

            if (rect.bottom < 0) {
                this.stickyBar.classList.add("active")
            } else {
                this.stickyBar.classList.remove("active")
            }

        })

    }

    getPrice(el) {
        return parseFloat(el.dataset.price || 0)
    }

    isContactMode() {

        return (
            this.selected?.stone?.contact ||
            this.selected?.metal?.contact
        )

    }

    initStone() {

        const stones = document.querySelectorAll(".stone-card")

        stones.forEach(card => {

            card.addEventListener("click", () => {

                stones.forEach(c => c.classList.remove("active"))

                card.classList.add("active")

                this.selected.stone = {
                    id: card.dataset.product,
                    price: this.getPrice(card),
                    name: card.dataset.name,
                    contact: card.dataset.contact === "true"
                }

                this.updatePrice()

            })

        })

        if (stones.length) stones[0].click()

    }

    initMetal() {

        const metals = document.querySelectorAll(".rc-metal")

        metals.forEach(m => {

            m.addEventListener("click", () => {

                metals.forEach(x => x.classList.remove("active"))

                m.classList.add("active")
                console.log('Metal selected:', m);
                if (m.dataset.active !== "true") {

                    this.selected.metal = {
                        id: m.dataset.product,
                        price: this.getPrice(m),
                        name: m.dataset.name,
                        contact: m.dataset.contact === "true"
                    }

                } else {

                    this.selected.metal = null

                }

                this.updatePrice()

            })

        })

    }

    initRingType() {

        const types = document.querySelectorAll(".rc-ring-type")

        types.forEach(t => {

            t.addEventListener("click", () => {

                types.forEach(x => x.classList.remove("active"))

                t.classList.add("active")

                if (t.dataset.active !== "true") {

                    this.selected.ring = {
                        id: t.dataset.product,
                        name: t.dataset.name,
                        price: this.getPrice(t)
                    }

                } else {

                    this.selected.ring = null

                }

                this.updatePrice()

            })

        })

    }

    initExpress() {

        const checkbox = document.querySelector("#expressProduction")

        if (!checkbox) return

        checkbox.addEventListener("change", () => {

            this.selected.express = checkbox.checked

            this.updatePrice()

        })

    }

    initPersonalEngraving() {

        const checkbox = document.querySelector("#personalEngraving")
        const wrapper = document.querySelector("#engravingInputWrapper")

        if (!checkbox) return

        checkbox.addEventListener("change", () => {

            this.selected.engraving = checkbox.checked

            if (wrapper) wrapper.style.display = checkbox.checked ? "block" : "none"

            this.updatePrice()

        })

    }

    updateSticky(price) {

        const formattedPrice = Shopify.formatMoney(price)

        /* UPDATE OPTIONS */

        this.stickyStone.innerText =
            this.selected?.stone?.name || "Stone"

        this.stickyMetal.innerText =
            this.selected?.metal?.name || "Metal"

        this.stickyRing.innerText =
            this.selected?.ring?.name || "Ring"

        /* CONTACT MODE */

        if (this.isContactMode()) {

            this.stickyPrice.innerText = "Request Quote"

            this.stickyAdd.innerText = "Request Custom Quote"

            this.stickyAdd.onclick = () => {
                window.location.href = "/pages/contact"
            }

            return
        }

        /* NORMAL MODE */

        this.stickyPrice.innerText = formattedPrice

        this.stickyAdd.innerText = `Start Your Mirroring — ${formattedPrice}`

        this.stickyAdd.onclick = () => this.addToCart()

    }

    updatePrice() {

        /* CALCULATE PRICE */

        let price = this.selected.stone?.price || 0

        if (this.selected.metal)
            price += this.selected.metal.price

        if (this.selected.ring)
            price += this.selected.ring.price

        if (this.selected.express) {

            const express = document.querySelector("#expressProduction")

            const expressPrice = parseFloat(
                express?.dataset?.price || 99
            )

            price += expressPrice

        }

        if (this.selected.engraving) {

            const engravingEl = document.querySelector("#personalEngraving")

            const engravingPrice = parseFloat(engravingEl?.dataset?.price || 0)

            price += engravingPrice

        }

        const formattedPrice = Shopify.formatMoney(price)

        /* UPDATE STICKY BAR ALWAYS */

        this.updateSticky(price)

        /* CONTACT MODE */

        if (this.isContactMode()) {

            this.priceEl.innerText = "Request Quote"

            this.button.innerText = "Request Custom Quote"

            this.button.onclick = () => {
                window.location.href = "/pages/contact"
            }

            return
        }

        /* NORMAL MODE */

        this.priceEl.innerText = formattedPrice

        this.button.innerText = `Start Your Mirroring — ${formattedPrice}`

        this.button.onclick = () => this.addToCart()

    }

    addToCart() {

        if (this.isContactMode()) {

            window.location.href = "/pages/contact"
            return

        }

        const items = []

        if (this.selected.stone) {
            items.push({
                id: this.selected.stone.id,
                quantity: 1
            })
        }

        if (this.selected.metal) {
            items.push({
                id: this.selected.metal.id,
                quantity: 1
            })
        }

        if (this.selected.ring) {
            items.push({
                id: this.selected.ring.id,
                quantity: 1
            })
        }

        if (this.selected.express) {

            const expressVariant = document.querySelector("#expressProduction")?.dataset?.product

            if (expressVariant) {

                items.push({
                    id: expressVariant,
                    quantity: 1
                })

            }

        }

        if (this.selected.engraving) {

            const engravingVariant = document.querySelector("#personalEngraving")?.dataset?.product
            const engravingText = document.querySelector("#engravingText")?.value || ""

            if (engravingVariant) {

                items.push({
                    id: engravingVariant,
                    quantity: 1,
                    properties: {
                        "personal-engraving": engravingText
                    }
                })

            }

        }

        fetch("/cart/add.js", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    items
                })
            })
            .then(() => {

                window.location.href = "/checkout"

            })

    }

}

document.addEventListener("DOMContentLoaded", () => {

    new RingConfigurator()

})